module.exports = __webpack_public_path__ + "img/Icon_High_winning.bebb0836.png";